<template>
  <div class="tabs-container">
    <!-- LOADER -->
    <div v-if="loading" class="loading-screen">
      <div>
        <Loader />
      </div>
    </div>
    <!-- Tab headers -->
    <div class="tabs">
      <div
        class="tab"
        :class="{ active: activeTab === 'overview' }"
        @click="activeTab = 'overview'"
      >
        Overview
      </div>
      <div
        class="tab"
        :class="{ active: activeTab === 'reviews' }"
        @click="activeTab = 'reviews'"
      >
        Reviews <span class="count">{{ reviews.length }}</span>
      </div>
    </div>

    <!-- Tab content -->
    <div class="tab-content">
      <!-- Reviews tab content -->
      <div v-if="activeTab === 'reviews'">
        <div v-if="reviews.length === 0" class="empty-state">
          <div class="calendar-icon">
            <img src="@/assets/icons/empty-state.svg" alt="" />
          </div>
          <h3 class="mt-3">No reviews available</h3>
          <p>Available reviews will appear here.</p>
        </div>
        <div v-else>
          <div class="reviews-container">
            <!-- Reviews List -->
            <div class="reviews-list">
              <div
                v-for="(review, index) in displayedReviews"
                :key="index"
                class="review-item"
              >
                <!-- Star Rating -->
                <div class="rating">
                  <span
                    v-for="i in 5"
                    :key="i"
                    class="star"
                    :class="{ filled: i <= review.rating }"
                    >★</span
                  >
                </div>

                <!-- Review Content -->
                <p class="review-text">
                  {{ review.review }}
                  <span
                    v-if="review.review.length > 150"
                    class="see-more"
                    @click="toggleExpandReview(index)"
                  >
                    <!-- {{ review.expanded ? "See less" : "See more" }} -->
                  </span>
                </p>

                <!-- Reviewer Info -->
                <div class="reviewer-info">
                  <span class="reviewer-name"
                    >{{toSentenceCase(review.user.firstname)  }}
                    {{toSentenceCase( review.user.lastname) }}</span
                  >
                  <span class="dot-separator">•</span>
                  <span class="review-date">{{ review.date }} </span>
                </div>
              </div>
            </div>

            <!-- Pagination -->
            <!-- <div class="pagination">
              <div class="page-info">
                Page {{ currentPage }} of {{ totalPages }}
              </div>
              <div class="pagination-controls">
                <button
                  class="pagination-btn"
                  :class="{ disabled: currentPage === 1 }"
                  @click="changePage(currentPage - 1)"
                  :disabled="currentPage === 1"
                >
                  Previous
                </button>
                <button
                  class="pagination-btn"
                  :class="{ disabled: currentPage === totalPages }"
                  @click="changePage(currentPage + 1)"
                  :disabled="currentPage === totalPages"
                >
                  Next
                </button>
              </div>
            </div> -->
          </div>
        </div>
      </div>

      <!-- Overview tab content -->
      <div v-if="activeTab === 'overview'">
        <div class="overview-container">
          <div class="reviewer-info overview">
            <span class="reviewer-name">{{ multiFormData.businessName }}</span>
            <span class="dot-separator">•</span>
            <span class="review-name"
              >Minimum price ₦
              {{  formatNumberWithCommas(multiFormData.minimumRate) }}
            </span>
          </div>

          <div>
            <!-- <p>
                 Lorem ipsum dolor sit amet consectetur. Tortor laoreet volutpat massa felis leo tortor. Dolor non nulla laoreet vel nullam scelerisque nulla aliquam sed. Volutpat ultrices porta sit velit nisl vitae posuere nunc dictumst. In adipiscing congue id sit.
            </p> -->
          </div>
        </div>

        <!-- Business Registration (Default Open) -->
        <div class="accordion-container">
          <div class="accordion-header" @click="toggleDropdown('registration')">
            <div>
              <div class="info-header">
                <span>Business registration</span>
                <span class="text-blue">
                  <router-link to="vendors/edit-vendor-profile"> Edit </router-link>
                </span>
              </div>
            </div>
            <!-- <span
              v-html="activeDropdown === 'registration' ? '' : dropdownIcon"
            ></span> -->
            <div>
              <div class="info-card-field">
                <div class="info-card-label">Business registration name</div>
                <div class="info-card-value">
                  {{ multiFormData.businessName }}
                </div>
              </div>
              <div class="info-card-field">
                <div class="info-card-label">Business issuing body</div>
                <div class="info-card-value">{{ multiFormData.businessIssuingBody }}</div>
              </div>

              <div class="info-card-field">
                <div class="info-card-label">Business address</div>
                <div class="info-card-value">{{ multiFormData.businessAddress }}</div>
              </div>
            </div>
          </div>
        </div>

        <!-- Certification Details -->
        <div class="accordion-container">
          <div
            class="accordion-header"
            @click="toggleDropdown('certification')"
          >
            <div class="info-header">
              <span>Certification Details</span>
              <span class="text-blue">
                <router-link to="vendors/edit-vendor-profile"> Edit </router-link>
              </span>
            </div>
            <div
              v-show="activeDropdown === 'certification'"
              class="accordion-subtitle"
            >
              <div class="info-card-field">
                <div class="info-card-label">Certification name</div>
                <div class="info-card-value">
                  {{ multiFormData.certificationName }}
                </div>
              </div>
              <div class="info-card-field">
                <div class="info-card-label">Issuing organization</div>
                <div class="info-card-value">
                  {{ multiFormData.issuingOrg }}
                </div>
              </div>
              <div class="info-card-field">
                <div class="info-card-label">Date obtained</div>
                <div class="info-card-value">
                  {{ multiFormData.certificationDate | moment }}
                </div>
              </div>
            </div>

            <span
              v-html="activeDropdown === 'certification' ? '' : dropdownIcon"
            ></span>
          </div>
        </div>

        <!-- Work Samples -->
        <div class="accordion-container">
          <div class="accordion-header" @click="toggleDropdown('workSamples')">
            <div>
              <div class="info-header">
                <span>Work samples</span>
                <span class="text-blue">
                  <router-link to="vendors/edit-vendor-profile"> Edit </router-link>
                </span>
              </div>
              <div
                v-show="activeDropdown === 'workSamples'"
                class="accordion-subtitle"
              ></div>
            </div>

            <span
              v-html="activeDropdown === 'workSamples' ? '' : dropdownIcon"
            ></span>
          </div>

          <div
            v-if="activeDropdown === 'workSamples'"
            class="accordion-content"
          >
            <div class="tips-box">
              <span class="tips-icon"
                ><svg
                  width="16"
                  height="20"
                  viewBox="0 0 16 20"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <g clip-path="url(#clip0_3663_137326)">
                    <path
                      d="M7.33333 4V6H8.66667V4H7.33333ZM2.8151 5.8724L1.8724 6.8151L3.28646 8.22917L4.22917 7.28646L2.8151 5.8724ZM13.1849 5.8724L11.7708 7.28646L12.7135 8.22917L14.1276 6.8151L13.1849 5.8724ZM8 7.33333C5.43044 7.33333 3.33333 9.43044 3.33333 12C3.33333 13.8452 4.43741 15.4015 6 16.1562V18C6 18.7287 6.60463 19.3333 7.33333 19.3333H8.66667C9.39538 19.3333 10 18.7287 10 18V16.1562C11.5626 15.4015 12.6667 13.8452 12.6667 12C12.6667 9.43044 10.5696 7.33333 8 7.33333ZM8 8.66667C9.84911 8.66667 11.3333 10.1509 11.3333 12C11.3333 13.4562 10.4036 14.6819 9.11068 15.1393L8.66667 15.2956V18H7.33333V15.2956L6.88932 15.1393C5.59644 14.6819 4.66667 13.4562 4.66667 12C4.66667 10.1509 6.15089 8.66667 8 8.66667ZM0 11.3333V12.6667H2V11.3333H0ZM14 11.3333V12.6667H16V11.3333H14ZM3.28646 15.7708L1.8724 17.1849L2.8151 18.1276L4.22917 16.7135L3.28646 15.7708ZM12.7135 15.7708L11.7708 16.7135L13.1849 18.1276L14.1276 17.1849L12.7135 15.7708Z"
                      fill="#B54708"
                    />
                  </g>
                  <defs>
                    <clipPath id="clip0_3663_137326">
                      <rect width="16" height="19.3333" fill="white" />
                    </clipPath>
                  </defs>
                </svg>
              </span>
              <p class="tips-text">
                To foster trust and showcase the quality of your work, add
                images of the 'before' and 'after' states of your work.
              </p>
            </div>

            <div>
              <div v-if="multiFormData.workSamples.length <= 0">
                <EmptyState :emptyData="emptyImgObject" />
              </div>
              <div
                v-else
                class="work-samples-container"
                v-for="(item, index) in multiFormData.workSamples"
                :key="index"
              >
                <div class="work-sample">
                  <div class="work-sample-header">
                    <!-- <button class="text-blue">Edit</button> -->
                  </div>

                  <p class="work-summary">
                    <strong>Work summary:</strong>
                    <span> {{ item.work_summary }}</span>
                  </p>
                </div>
                <div class="image-preview">
                  <img
                    :src="item.url"
                    alt="Work_sample_image"
                    class="uploaded-image"
                  />
                  <!-- <img src="@/assets/images/happy_customer.jpg" class="uploaded-image" alt=""> -->
                  <!-- <img src="@/assets/images/happy_customer.jpg" class="uploaded-image" alt=""> -->
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Loader from "../components/Loader.vue";
import setVendorProfile from "../services/vendorprofile";
import EmptyState from "../components/EmptyState.vue";
import moment from 'moment'

export default {
  components: { Loader, EmptyState },
  data() {
    return {
      loading: false,
      loadingDetails: false,
      responseLoading: false,
      cancelLoader: false,
       activeDropdown: "certification", // This should be open by default

      dataLoaded: false,
      minimumRate: null,
      activeTab: "overview", // Default tab is overview"
      newExpandedStates: [false],
      emptyImgObject: {
        header: "No images found",
        option: "Please upload an image and try again",
      },
      currentPage: 1,
      reviewsPerPage: 3,
      totalReviews: 10,
      reviews: [],
      multiFormData: {
        businessName: "",
        businessAddress: "",
        aboutDescription: "",
        service: "",
        rate: "",
        registrationName: "",
        businessIssuingBody: "",
        certificationName: "",
        issuingOrg: "",
        certificationDate: "",
        workSamples: [],
        workSummary: "",
        minimumRate: "",
      },
      dropdowns: {
        registration: true,
        certification: false,
        workSamples: false,
      },
      dropdownIcon: `<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">`,
    };
  },
  filters: {
    moment: function(date) {
      return moment(date).format('MMMM Do YYYY');
    }
    // moment: function(date) {
    //   return moment(date).format('MMMM DD YYYY, h:mm:ss a');
    // }
  },
  immediate: true,

  methods: {
    toggleDropdown(section) {
      this.activeDropdown = this.activeDropdown === section ? null : section;
    },
    toSentenceCase(text) {
    if (!text) return '';
    const lower = text.toLowerCase();
    return lower.charAt(0).toUpperCase() + lower.slice(1);
  },
    changePage(page) {
      if (page >= 1 && page <= this.totalPages) {
        this.currentPage = page;
      }
    },
    toggleExpandReview(index) {
      const review = { ...this.displayedReviews[index] };
      review.expanded = !review.expanded;

      // Calculate the actual index in the full reviews array
      const actualIndex = (this.currentPage - 1) * this.reviewsPerPage + index;

      // Update the review in the full array
      this.$set(this.reviews, actualIndex, review);
    },

    formatNumberWithCommas(value) {
  if (!value) return "0";

  // Remove anything that's not a digit (₦, commas, etc.)
  const numericString = value.toString().replace(/[^\d]/g, '');
  const number = Number(numericString);

  if (isNaN(number)) return "0";

  return number.toLocaleString();
}


   

    
  },

  computed: {
    
    totalPages() {
      return Math.ceil(this.reviews.length / this.reviewsPerPage);
    },
    displayedReviews() {
      const start = (this.currentPage - 1) * this.reviewsPerPage;
      const end = start + this.reviewsPerPage;
      return this.reviews.slice(start, end);
    },
  },

  created() {
    this.loading = true;

    let userID = this.$store.getters.getUser.id;

    setVendorProfile
      .vendorProfileOverview(userID)
      .then((data) => {
        // console.log("data", data)
        this.totalEarnings = data.earnings;
        this.impressions = data.impressions;
        if (data.main_data != null) {
          this.minimumRate = data.main_data.minimum_rate || "";
          this.multiFormData.businessIssuingBody =
          data.main_data.business_registration_issuing_body || "No business issuing body available";
          this.multiFormData.businessName = data.main_data.business_name || "No business name available";
          this.multiFormData.certificationName = data.main_data.certification_name || "No certification name";
          this.multiFormData.businessAddress =  data.main_data.business_address || "No business address found";
          this.multiFormData.issuingOrg = data.main_data.certification_issuing_body || "No certification issuing body found";
          this.multiFormData.certificationDate = data.main_data.certification_date_obtained || "No certification date found";
        }
        this.reviews = data.reviews;
        this.multiFormData.workSamples = data.uploads || [];
      })
      .catch((error) => {
        console.log("Error", error);
      })
      .finally(() => {
        this.loading = false;
      });
  },
};
</script>

<style scoped>
/* Loading Screen */
.loading-screen {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(255, 255, 255, 0.9);
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}
.text-blue {
  color: #0033ea !important;
  font-size: 14px !important;
  font-weight: 400 !important;
}
/* Tab container */
.tabs-container {
  width: 100%;
  margin: 20px auto 0;
  background-color: #fff;
  border-radius: 16px;
}

/* Tabs styling */
.tabs {
  display: flex;
  border-bottom: 1px solid #e5e7eb;
  width: 100%;
}

.tab {
  padding: 16px;
  cursor: pointer;
  position: relative;
  color: #555c74;
  font-weight: 600;
  font-size: 16px;
  transition: color 0.2s ease;
}

.tab:hover {
  color: #0033ea;
}

.tab.active {
  color: #0033ea;
}

.tab.active::after {
  content: "";
  position: absolute;
  bottom: -1px;
  left: 0;
  width: 100%;
  height: 2px;
  background-color: #0033ea;
}

.count {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  margin-left: 8px;
  background-color: #fafafa;
  color: #555c74;
  border-radius: 9999px;
  padding: 2px 8px;
  font-size: 14px;
  border: 1px solid #e9eaeb;
  min-width: 24px;
}

/* Tab content */
.tab-content {
  padding: 16px;
}

/* Empty state */
.empty-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 48px 24px;
  text-align: center;
  background-color: #fafafa;
  border-radius: 8px;
}

.calendar-icon {
  margin-bottom: 16px;
  color: #9ca3af;
}

.empty-state h3 {
  font-size: 14px;
  font-weight: 600;
  margin-bottom: 8px;
  color: #2b3352;
}

.empty-state p {
  color: #555c74;
  font-size: 14px;
  font-weight: 400;
  max-width: 400px;
}

/* General container */
.accordion-container {
  border: 1px solid hsla(210, 5%, 92%, 1);
  border-radius: 8px;
  margin: 10px 0;
  background: #fff;
}

/* Header styling */
.accordion-header {
  display: flex;
  flex-direction: column;
  justify-content: center;
  /* align-items: center; */
  padding: 24px 16px;
  font-weight: 600;
  border-top-right-radius: 8px;
  border-top-left-radius: 8px;
  cursor: pointer;
  border: 1px solid hsla(210, 5%, 92%, 1);
  background: #fff;
}

.accordion-header span {
  color: hsla(228, 31%, 25%, 1);
  font-weight: 500;
  font-size: 18px;
}

.tips-box {
  background: hsla(45, 100%, 96%, 1);
  padding: 16px 10px;
  border-radius: 8px;
  display: flex;
  width: 98%;
  margin: 20px auto;
  gap: 15px;
}

.tips-text {
  font-size: 14px;
  color: hsla(226, 15%, 39%, 1);
  font-weight: 400;
}

/* WORK SAMPLS IMAGES */

.work-samples-container {
  padding: 20px;
  border: 1px solid hsla(210, 5%, 92%, 1);
  border-radius: 8px;
  background: #fff;
}

.work-sample {
  margin-bottom: 15px;
  padding-bottom: 10px;
  border-bottom: 1px solid hsla(210, 5%, 92%, 1);
}

.work-sample-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: hsla(228, 31%, 25%, 1);
  font-weight: 600;
  font-size: 18px;
}

/* Subtitle (Hidden when closed) */
.accordion-subtitle {
  font-size: 14px;
  font-weight: 400;

  color: hsla(226, 15%, 39%, 1);
  margin-top: 10px;
}

.accordion-content {
  padding: 12px;
  border-top: 1px solid hsla(210, 5%, 92%, 1);
  background: #fff;
  margin: 10px 0;
}

.input-field {
  width: 100%;
  padding: 8px 14px;
  margin-bottom: 10px;
  margin-top: 5px;
  border: 1px solid hsla(216, 6%, 85%, 1);
  border-radius: 8px;
}

input:focus,
.dropdown-input:focus,
textarea:focus {
  outline: none;
}

.image-preview {
  display: flex !important;
  gap: 10px;
  margin-top: 30px;

  flex-wrap: wrap !important;
  overflow: scroll;
  width: 100%;
  /* width: 130px;
  height: 130px; */
}

.uploaded-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 6px;
  width: 130px;
  height: 130px;
}
/* REVIEWS */
.reviews-container {
  width: 100%;
  margin: 0 auto;
  padding: 20px 0;
  color: #333;
}

/* Tabs Navigation */
.tabs {
  display: flex;
  border-bottom: 1px solid #e0e0e0;
  margin-bottom: 20px;
}

.tab {
  padding: 10px 15px;
  cursor: pointer;
  position: relative;
  color: #666;
}

.tab.active {
  color: #0033ea;
  font-weight: 600;
}

.tab.active::after {
  content: "";
  position: absolute;
  bottom: -1px;
  left: 0;
  width: 100%;
  height: 2px;
  background-color: #0033ea;
}

.review-count {
  margin-left: 5px;
  font-size: 0.9em;
}

/* REVIEW INFO */

.info-card-field {
  margin: 15px 0;
}

.info-card-label {
  font-size: 14px;
  color: hsla(228, 31%, 25%, 1);
  font-weight: 600;
  margin-bottom: 5px;
}

.info-card-value {
  font-size: 12px;
  color: hsla(226, 15%, 39%, 1);
}

.info-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

/* Reviews List */
.reviews-list {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.review-item {
  padding: 15px 0;
  border-bottom: 1px solid #e0e0e0;
}

/* Star Rating */
.rating {
  margin-bottom: 10px;
}

.star {
  color: hsla(0, 0%, 96%, 1);
  font-size: 20px;
}

.star.filled {
  color: hsla(42, 99%, 65%, 1);
}

/* Review Content */
.review-text {
  margin-bottom: 10px;
  line-height: 1.5;
  color: hsla(226, 15%, 39%, 1);
}

.see-more {
  color: hsla(227, 100%, 43%, 1);
  cursor: pointer;
  font-weight: 600;
  margin-left: 5px;
}

/* Reviewer Info */
.reviewer-info {
  display: flex;
  align-items: center;
  font-size: 16px;
  color: hsla(226, 15%, 39%, 1);
}

.reviewer-name {
  font-weight: 400;
  font-size: 14px;
  color: hsla(226, 15%, 39%, 1);
}

.reviewer-info.overview {
  font-weight: 500 !important;
  color: hsla(228, 31%, 25%, 1) !important;
  margin: 0 0 20px;
}

.dot-separator {
  margin: 0 12px;
}

/* Pagination */
.pagination {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 30px;
  padding-top: 15px;
}

.page-info {
  font-size: 14px;
  color: hsla(228, 31%, 25%, 1);
}

.pagination-controls {
  display: flex;
  gap: 10px;
  margin-top: 12px;
}

.pagination-btn {
  padding: 8px 15px;
  border: 1px solid hsla(216, 6%, 85%, 1);
  border-radius: 4px;
  background: hsla(0, 0%, 100%, 1);
  cursor: pointer;
  transition: all 0.2s ease;
  color: hsla(226, 17%, 35%, 1);
}

.pagination-btn:hover:not(.disabled) {
  background-color: hsla(0, 0%, 100%, 1);
}

.pagination-btn.disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.overview-container {
  font-size: 14px !important;
  color: hsla(226, 15%, 39%, 1);
  margin: 20px 0;
  width: 100%;
}

/* Responsive Styles */
@media (max-width: 600px) {
  .reviews-container {
    padding: 15px;
  }

  .pagination {
    flex-direction: column;
    gap: 15px;
    align-items: flex-start;
  }

  .pagination-controls {
    width: 100%;
  }

  .pagination-btn {
    flex: 1;
    text-align: center;
  }

  .reviewer-info {
    flex-direction: column;
    align-items: flex-start;
    gap: 5px;
  }

  .dot-separator {
    display: none;
  }
}
</style>
